import moment from 'moment';
const Message = function (props) {
    
    let toggleItemsClass =props.itemNum == 0 ? '' : 'messages-multi-collapse ';
    let toggleItemsClass2 =props.itemNum == 0 ? '' : ' collapse ';
    let toggleItemsClass3 =props.itemNum == 0 ? 'collapse' : ' ';
    let firstItemClass = props.itemNum == 0 && !props.showItems ? 'text-truncate' : '';
    let collapseClass = !props.showItems ? 'hideMessage' : '';

    return (
        <div className={"col-12 "+toggleItemsClass + toggleItemsClass2} id={'message' +props.data.ID} 
                onClick={props.clicked} data-target=".messages-multi-collapse" data-toggle="collapse">
             <div className="row no-gutters messageWrap">
                 {props.data.MODPublishDate&&<div className="col-3 col-md-1 messageDate" >{moment(props.data.MODPublishDate).format('DD.MM')} </div>}
                  <div className='col-9 col-md-11' >
                    <div className={'messageTitle ' +firstItemClass} >{props.data.Title}</div>
                    <div className={'messageDetails messages-multi-collapse '+toggleItemsClass3}  dangerouslySetInnerHTML={{__html: props.data.MODMessageText}} ></div>
                </div>
            </div>
        </div>
    );
}

export default Message;